import axios from 'axios';

export const START_GET_SEARCH_REGION_DATA = 'START_GET_SEARCH_REGION_DATA';
export const END_GET_SEARCH_REGION_DATA = 'END_GET_SEARCH_REGION_DATA';
export const SET_SEARCH_REGION_DATA = 'SET_SEARCH_REGION_DATA';

const startGetSearchRegionData = () => {
  return {
    type: START_GET_SEARCH_REGION_DATA
  };
};

const endGetSearchRegionData = (params, response) => {
  return {
    type: END_GET_SEARCH_REGION_DATA,
    params,
    response
  };
};

const setSearchRegionData = (data) => {
  return {
    type: SET_SEARCH_REGION_DATA,
    data
  };
};

const setRegionSearchData = data => {
  return (dispatch) => {
    dispatch(setSearchRegionData(data));
  };
};

const getSearchRegionData = (params) => {
  let reqParams = {
    contentId: params.contentId
  };

  return (dispatch) => {
    dispatch(startGetSearchRegionData());
    axios({
      method: 'GET',
      url: `/api/search/getsearchregiondata?${Object.keys(reqParams)
        .reduce((a, k) => {
          a.push(k + '=' + encodeURIComponent(reqParams[k]));
          return a;
        }, [])
        .join('&')}`
    }).then((response) => dispatch(endGetSearchRegionData(params, response)));
  };
};

export { getSearchRegionData, setRegionSearchData };
